import {createSelector} from '@reduxjs/toolkit';
import {TStateStore} from 'store';

const getProgramsState = (state: TStateStore) => state.programs.classDetails;

export const activeEntitySelector = createSelector(getProgramsState, (details) => details.activeEntity);
export const loadingSelector = createSelector(getProgramsState, (details) => details.loading);
